import React, { useState, useRef, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { authApi } from '../api/api';
import { clearUserAuth, TOKEN_KEYS } from '../utils/tokenUtils';
import logo from '../assets/images/vedic-wisdom-logo.png'; // Adjust the path as needed
import styles from '../styles/Header.module.css';
import { PLAY_STORE_URL } from '../config/constants';

const links = [
  { to: '/consultant/profile', label: 'My Profile' },
  { to: '/consultant/wallet-recharge', label: 'Wallet Recharge' },
  { to: '/consultant/wallet-passbook', label: 'Passbook' },
  { to: '/consultant/order-history', label: 'Order History' },
  { to: '/consultant/profile-list', label: 'Profile List' }
];

const Header = () => {
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const navigate = useNavigate();
    const dropdownRef = useRef(null);

    // Debug: Log raw and parsed user from localStorage
    const rawUser = localStorage.getItem(TOKEN_KEYS.USER_INFO);
    let user = null;
    try {
      user = JSON.parse(rawUser);
    } catch (e) {
      user = null;
    }

    const handleLogout = async () => {
      try {
        // Get refresh token before clearing localStorage
        const refreshToken = localStorage.getItem(TOKEN_KEYS.USER_REFRESH);
        
        // Call server-side logout to invalidate refresh token
        if (refreshToken) {
          try {
            await authApi.post('/auth/logout', { refreshToken });
           
          } catch (logoutError) {
            console.warn('⚠️ Server-side logout failed (continuing with client logout):', logoutError.message);
          }
        }
        
        // Clear all user authentication data
        clearUserAuth();
        
        // Close dropdown and navigate to home
        setDropdownOpen(false);
        navigate('/');
        
      } catch (error) {
        console.error('❌ Logout error:', error);
        // Even if server logout fails, clear client-side data
        clearUserAuth();
        setDropdownOpen(false);
        navigate('/');
      }
    };

    // Close dropdown when clicking outside
    useEffect(() => {
      if (!dropdownOpen) return;
      const handleClick = (e) => {
        if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
          setDropdownOpen(false);
        }
      };
      document.addEventListener('mousedown', handleClick);
      return () => document.removeEventListener('mousedown', handleClick);
    }, [dropdownOpen]);

    return (
        <header className={styles.header}>
            <div className={styles.headerContainer}>
                <div className={styles.logo}>
                    <img src={logo} alt="Vedic Wisdom"/>
                </div>
                <div className={styles.mobileMenuToggle}>
                    <i className="fas fa-bars"></i> Menu
                </div>
                <div className={styles.navContainer}>
                    <nav className={styles.mainNav}>
                        <ul>
                            <li><a href="/"><i className="fas fa-home"></i> Home</a></li>
                          
                            <li><a href="/aboutus"><i className="fas fa-book-open"></i>About us</a></li>
                        </ul>
                    </nav>
                    <div className={styles.headerActions}>
                        {!user ? (
                          <>
                            <a href={PLAY_STORE_URL} target="_blank" rel="noopener noreferrer" className="btn primary-btn">Login / Register</a>
                          </>
                        ) : (
                          <div className={styles.userDropdown} ref={dropdownRef}>
                            <button
                              className={styles.userDropdownBtn}
                              onClick={() => setDropdownOpen((open) => !open)}
                              aria-haspopup="true"
                              aria-expanded={dropdownOpen}
                            >
                              {user.name} &#x25BC;
                            </button>
                            {dropdownOpen && (
                              <div className={styles.userDropdownMenu}>
                                {links.map(link => (
                                  <Link
                                    key={link.to}
                                    to={link.to}
                                    className={styles.userDropdownLink}
                                    onClick={() => setDropdownOpen(false)}
                                  >
                                    {link.label}
                                  </Link>
                                ))}
                                <div className={styles.userDropdownDivider} />
                                <button
                                  className={styles.userDropdownLogout}
                                  onClick={handleLogout}
                                >
                                  Logout
                                </button>
                              </div>
                            )}
                          </div>
                        )}
                    </div>
                </div>
            </div>
        </header>
    );
};

export default Header;